import  React from 'react';
import _ from 'underscore';


// Opens entire page covering modal with option list. Used in language selection on front page
export const SelectionModal = ({title, items, onItemSelected, onClose, visible, value}) => {
  return(
    <div
      className="selection-modal"
      style={ {display: (visible ? "flex" : "none")} }
      onClick={ onClose }
    >
      <div className="modal-content">
        <h1 className="title">
          {title}
        </h1>
        <SelectionList
          options={items}
          onOptionSelected={(key) => onItemSelected(key)}
          value={value}
        />
      </div>
    </div>
  );
};


const SelectionList = ({options, onOptionSelected, value}) => {
  
  let list = _.map(options, (val, key) => {
    return(
      <div
        key={key}
        className="option"
        onClick={() => onOptionSelected(key)}
      >
        <div className="symbol">
          <div className={"fill " + (value == key ? "active" :  "")}></div>
        </div>
        <span className="value" id={val}>
          {val}
        </span>
      </div>
    );
  });
  list = _.sortBy(list, 'key');

  return(
    <div className="option-list">
      {list}
    </div>
  );
};
